import { ListMessageSectionOption } from 'apps/whatsApp/ListMessages/types'
import { FlowChartButtonStatsBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartButtonStatsBuilder'
import { FlowChartButtonStats } from 'common/builder/components/chart/FlowChart/types/FlowChartButton'

export class FlowChartButtonStatsConverter {
  static fromListMessageSectionOption(option: ListMessageSectionOption): FlowChartButtonStats {
    if (!option.button_click_stats) {
      return new FlowChartButtonStatsBuilder().build()
    }

    const { users = 0, clicks = 0, segment_id: segmentId = null } = option.button_click_stats

    return new FlowChartButtonStatsBuilder()
      .withUsers(users)
      .withClicks(clicks)
      .withSegmentId(segmentId)
      .build()
  }
}
